import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import API from "../axios";
import { useNavigate } from "react-router-dom";

const CreateExpectedResult = () => {
    const naviate = useNavigate();

    const [name, setName] = useState("");
    const [key, setKey] = useState("");
    const [newSubCategory, setNewSubCategory] = useState("");
    const [newValue, setNewValue] = useState("");
    const [exampleValue, setExampleValue] = useState("");

    const [currentSubCategory, setCurrentSubCategory] = useState("");
    const [currentField, setCurrentField] = useState("");

    const [rowInputs, setRowInputs] = useState<
        Record<string, { key: string; type: string; exampleText: string }>
    >({});

    const [rowValues, setRowValues] = useState<
        Record<string, Record<string, string>>
    >({});
    const [data, setData]: any = useState({});

    const handleAddNewSubCategory = () => {
        setData({
            ...data, // spread existing data
            [newSubCategory]: {}, // add the new subcategory
        });
    };

    const handleDeleteRow = (subCategory: string, key: string) => {
        const updatedData = { ...data };

        if (updatedData[subCategory]) {
            delete updatedData[subCategory][key];
        }

        setData(updatedData);
    };

    const handleDeleteItem = (
        subCategory: string,
        key: string,
        index: number
    ) => {
        const updatedData = { ...data };

        if (updatedData[subCategory]) {
            updatedData[subCategory][key].splice(index, 1);
        }

        setData(updatedData);
    };

    const handleAddNewValue = () => {
        const updatedData = {
            ...data,
            [currentSubCategory]: {
                ...data[currentSubCategory],
                [currentField]: [
                    ...(data[currentSubCategory][currentField] || []), // handle undefined
                    newValue,
                ],
            },
        };

        setData(updatedData);
        setNewValue("");
    };

    const handleAddNewRow = (subCategory: string) => {
        const input = rowInputs[subCategory];
        if (!input?.key || !input?.type) return;

        let value;
        if (input.type == "array") {
            value = [];
        } else {
            value = input.exampleText;
        }

        const updatedData = {
            ...data,
            [subCategory]: {
                ...data[subCategory],
                [input.key]: value,
            },
        };

        setData(updatedData);
        rowInputs[subCategory].key = "";
        rowInputs[subCategory].type = "null";
        rowInputs[subCategory].exampleText = "";
        setRowInputs({ ...rowInputs });
    };

    const handleConfirmGoback = () => {
        naviate("/expected-results");
    };

    const handleSave = async () => {
        const expectedResult = {
            name,
            key,
            json: data,
        };

        await API.createExpectedResult(expectedResult);
        naviate("/expected-results");
    };

    return (
        <div>
            <Container style={{ marginTop: 100 }}>
                <Row className="mb-5">
                    <Col
                        cols="6"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <a
                            type="button"
                            className="btn btn-outline-black btn-md mx-1"
                            href={`/expected-results`}
                            data-bs-toggle="modal"
                            data-bs-target="#gobackAlertModal"
                        >
                            <i className="bi bi-chevron-left"></i>
                        </a>
                        <h5 className="h5">Create Expected Results</h5>
                    </Col>
                    <Col cols="6" className="text-end">
                        <button
                            type="button"
                            className="btn btn-secondary mx-1 text-white"
                            data-bs-toggle="modal"
                            data-bs-target="#addSubCategoryModal"
                        >
                            <i className="bi bi-plus mx-2"></i>
                            Add New Sub-Category
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary mx-1"
                            onClick={handleSave}
                        >
                            <i className="bi bi-save mx-2"></i>
                            Save
                        </button>
                    </Col>
                </Row>
                <Row>
                    <Col cols="6">
                        <div className="mb-3">
                            <label className="form-label">Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <div id="emailHelp" className="form-text">
                                Specify the name for expected result
                            </div>
                        </div>
                    </Col>
                    <Col xs="6">
                        <div className="mb-3">
                            <label className="form-label">Key</label>
                            <input
                                type="text"
                                className="form-control"
                                value={key}
                                onChange={(e) => setKey(e.target.value)}
                            />
                            <div id="emailHelp" className="form-text">
                                Specify the key for functionality
                            </div>
                        </div>
                    </Col>
                    {Object.keys(data).map((subCategory: string) => (
                        <Col xs="12" className="mt-4">
                            <div className="mb-3 card">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th colSpan={3}>{subCategory}</th>
                                        </tr>
                                    </thead>
                                    <thead>
                                        <tr>
                                            <th
                                                scope="col"
                                                style={{ width: 300 }}
                                            >
                                                Key
                                            </th>
                                            <th
                                                scope="col"
                                                style={{ width: 500 }}
                                            >
                                                Values
                                            </th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(data[subCategory]).map(
                                            ([key, value]) => (
                                                <tr key={key}>
                                                    <td>{key}</td>
                                                    <td>
                                                        {Array.isArray(
                                                            value
                                                        ) ? (
                                                            value.map(
                                                                (v, idx) => (
                                                                    <span
                                                                        key={
                                                                            idx
                                                                        }
                                                                        className="badge bg-secondary mx-1 my-1"
                                                                        style={{
                                                                            fontSize: 10,
                                                                        }}
                                                                        onClick={() =>
                                                                            handleDeleteItem(
                                                                                subCategory,
                                                                                key,
                                                                                idx
                                                                            )
                                                                        }
                                                                    >
                                                                        {v}
                                                                        <i className="bi bi-trash mx-2"></i>
                                                                    </span>
                                                                )
                                                            )
                                                        ) : (
                                                            <span
                                                                className="text-muted"
                                                                style={{
                                                                    fontSize: 12,
                                                                }}
                                                            >
                                                                {
                                                                    value as string
                                                                }
                                                            </span>
                                                        )}
                                                        {/* Add New Button for Arrays */}
                                                        {Array.isArray(
                                                            value
                                                        ) && (
                                                            <span
                                                                // type="button"
                                                                // className="btn btn-secondary mx-1"
                                                                data-bs-toggle="modal"
                                                                // data-bs-target="#addSubCategoryModal"
                                                                className="badge bg-primary mx-1"
                                                                style={{
                                                                    fontSize: 10,
                                                                    cursor: "pointer",
                                                                }}
                                                                data-bs-target="#addNewValueModal"
                                                                onClick={() => {
                                                                    setCurrentSubCategory(
                                                                        subCategory
                                                                    );
                                                                    setCurrentField(
                                                                        key
                                                                    );
                                                                }}
                                                            >
                                                                <i className="bi bi-plus mx-2"></i>
                                                                Add New
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <span
                                                            className="badge bg-danger primary mx-1"
                                                            style={{
                                                                fontSize: 10,
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                                handleDeleteRow(
                                                                    subCategory,
                                                                    key
                                                                )
                                                            }
                                                        >
                                                            <i className="bi bi-trash mx-2"></i>
                                                            Delete Row
                                                        </span>
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                        {/* Optional: Input for adding new key-value */}
                                        <tr>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter key"
                                                    style={{ fontSize: 10 }}
                                                    value={
                                                        rowInputs[subCategory]
                                                            ?.key || ""
                                                    }
                                                    onChange={(e) =>
                                                        setRowInputs(
                                                            (prev) => ({
                                                                ...prev,
                                                                [subCategory]: {
                                                                    ...prev[
                                                                        subCategory
                                                                    ],
                                                                    key: e
                                                                        .target
                                                                        .value,
                                                                },
                                                            })
                                                        )
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <select
                                                    className="form-select"
                                                    aria-label="Default select example"
                                                    style={{ fontSize: 10 }}
                                                    value={
                                                        rowInputs[subCategory]
                                                            ?.type || ""
                                                    }
                                                    onChange={(e) =>
                                                        setRowInputs(
                                                            (prev) => ({
                                                                ...prev,
                                                                [subCategory]: {
                                                                    ...prev[
                                                                        subCategory
                                                                    ],
                                                                    type: e
                                                                        .target
                                                                        .value,
                                                                },
                                                            })
                                                        )
                                                    }
                                                >
                                                    <option
                                                        selected
                                                        value="null"
                                                    >
                                                        Select Type
                                                    </option>
                                                    <option value="array">
                                                        Array
                                                    </option>
                                                    <option value="input">
                                                        Input
                                                    </option>
                                                </select>
                                                <input
                                                    type="text"
                                                    className="form-control my-2"
                                                    placeholder="Enter Example Text (No need for array field)"
                                                    style={{ fontSize: 10 }}
                                                    value={
                                                        rowInputs[subCategory]
                                                            ?.exampleText || ""
                                                    }
                                                    onChange={(e) =>
                                                        setRowInputs(
                                                            (prev) => ({
                                                                ...prev,
                                                                [subCategory]: {
                                                                    ...prev[
                                                                        subCategory
                                                                    ],
                                                                    exampleText:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            })
                                                        )
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary mx-1 btn-sm"
                                                    onClick={() =>
                                                        handleAddNewRow(
                                                            subCategory
                                                        )
                                                    }
                                                >
                                                    <i className="bi bi-plus mx-2"></i>
                                                    Add New Row
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>

            {/* Add New Subcategory Modal */}
            <div
                className="modal fade"
                id="addSubCategoryModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Add New SubCategory
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <label className="form-label">
                                Sub Category Key
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="subcategory_key"
                                value={newSubCategory}
                                onChange={(e) =>
                                    setNewSubCategory(e.target.value)
                                }
                            />
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleAddNewSubCategory}
                            >
                                <i className="bi bi-plus mx-2"></i>
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add New Value */}
            <div
                className="modal fade"
                id="addNewValueModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Add New Value
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <label className="form-label">New Value</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter new value"
                                value={newValue}
                                onChange={(e) => setNewValue(e.target.value)}
                            />
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleAddNewValue}
                            >
                                <i className="bi bi-plus mx-2"></i>
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Dialog alert before going back */}
            <div
                className="modal fade"
                id="gobackAlertModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Confim To Go Back
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <p>
                                If you have updated data save it first. Unsaved
                                datas will be lost if you go back.
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={handleConfirmGoback}
                            >
                                Go Back
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateExpectedResult;
